import { actionConstants } from 'redux-layer/constants';
import {
  startReqActionType,
  successReqActionType,
  failReqActionType,
  apiHeader,
  processResponse
} from 'helper/requestHelper';
import { getEnvironment } from 'helper/utils';
import { NotificationManager } from 'react-notifications';

const workflowTemplateItemToOption = item => {
  return { value: String(item.id), label: String(item.id) };
};

export const fetchEventWorkflowTemplates = (customerId) => async () => {
  const requestOptions = {
    method: 'GET',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}events/workflow-templates?customer_id=${customerId}`,
      requestOptions
    );
    const raw = await processResponse(response);
    const list = raw.workflow_templates || [];
    return list
      .map(workflowTemplateItemToOption)
      .filter(Boolean);
  } catch (error) {
    NotificationManager.error(
      error.message || 'Failed to load workflow templates',
      'Error',
      3000
    );
    throw error;
  }
};

export const paginatedListEvents = (params, reset) => async dispatch => {
  dispatch({
    type: startReqActionType(actionConstants.PAGINATED_LIST_EVENTS)
  });
  const requestOptions = {
    method: 'GET',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}admin/events?${params}`,
      requestOptions
    );
    const data = await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.PAGINATED_LIST_EVENTS),
      payload: { ...data, reset }
    });
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.PAGINATED_LIST_EVENTS)
    });
    NotificationManager.error(
      error.message || 'Failed to load events',
      'Error',
      3000
    );
  }
};

export const getEventDetail = (customerId, eventId) => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.GET_EVENT_DETAIL) });
  const requestOptions = {
    method: 'GET',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}admin/event/${customerId}/${eventId}`,
      requestOptions
    );
    const data = await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.GET_EVENT_DETAIL),
      payload: data
    });
  } catch (error) {
    dispatch({ type: failReqActionType(actionConstants.GET_EVENT_DETAIL) });
    NotificationManager.error(
      error.message || 'Failed to load event',
      'Error',
      3000
    );
  }
};

export const createEvent = payload => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.CREATE_EVENT) });
  const requestOptions = {
    method: 'POST',
    headers: apiHeader(),
    body: JSON.stringify(payload)
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}admin/event`,
      requestOptions
    );
    const data = await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.CREATE_EVENT),
      payload: data
    });
    NotificationManager.success('Event created', 'Success', 3000);
    return data;
  } catch (error) {
    dispatch({ type: failReqActionType(actionConstants.CREATE_EVENT) });
    NotificationManager.error(
      error.message || 'Failed to create event',
      'Error',
      3000
    );
    throw error;
  }
};

export const updateEvent = (customerId, eventId, payload) => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.UPDATE_EVENT) });
  const requestOptions = {
    method: 'PUT',
    headers: apiHeader(),
    body: JSON.stringify(payload)
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}admin/event/${customerId}/${eventId}`,
      requestOptions
    );
    const data = await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.UPDATE_EVENT),
      payload: data
    });
    NotificationManager.success('Event updated', 'Success', 3000);
    return data;
  } catch (error) {
    dispatch({ type: failReqActionType(actionConstants.UPDATE_EVENT) });
    NotificationManager.error(
      error.message || 'Failed to update event',
      'Error',
      3000
    );
    throw error;
  }
};

export const deleteEvent = (customerId, eventId) => async dispatch => {
  dispatch({ type: startReqActionType(actionConstants.DELETE_EVENT) });
  const requestOptions = {
    method: 'DELETE',
    headers: apiHeader()
  };

  try {
    const response = await fetch(
      `${getEnvironment().API_URL}admin/event/${customerId}/${eventId}`,
      requestOptions
    );
    await processResponse(response);
    dispatch({
      type: successReqActionType(actionConstants.DELETE_EVENT),
      payload: { eventId }
    });
    NotificationManager.success('Event deleted', 'Success', 3000);
  } catch (error) {
    dispatch({ type: failReqActionType(actionConstants.DELETE_EVENT) });
    NotificationManager.error(
      error.message || 'Failed to delete event',
      'Error',
      3000
    );
    throw error;
  }
};
